export default function openMore() {

    $('._open-less, ._open-more').on('click', function (e) {
        e.preventDefault();
        $(this).parent('.section-sale__wrap').toggleClass('_active');
    });
}